<div class="full-view flex-centered boxWrapper">
  <div class="basic-text d-flex flex-column bg-white rounded-3 m-3 p-5">
    <h3 class="headline-text">Ups, da ist etwas schiefgelaufen!</h3>
    <p>Bitte wende dich an unseren Support <a href="mailto:startups@de.markant.com">startups&#64;de.markant.com</a> – wir helfen dir gerne weiter.</p>
    <i>Dein voilà! Team.</i>
  </div>
</div>
